const secondary = {
    social_bind_with: 'Já tinha uma conta? Faça login no link {{methods, list(type: disjunction;)}} com sua identidade social.',
};
export default secondary;
